The details of the created position opening.
